// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1ZGc1","amount":"Amount_amount__22fuM","tip":"Amount_tip__3O54X","tipHeader":"Amount_tipHeader__1cN1v","tipsWrap":"Amount_tipsWrap__1V34d"};